<script lang="ts">
  interface Props {
    children?: import("svelte").Snippet;
    class?: string;
  }

  let { children, class: className }: Props = $props();
</script>

<div class="ml-9 {className == undefined ? '' : className}">
  {@render children?.()}
</div>
